import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Space, Typography, Input, Checkbox, Form } from 'antd';
import { defaultPrefix } from 'all-in-one-shared-api';

import { MobileNumberPrefix } from 'components';
import { CommonTnc } from 'components/CommonTnc';

import { SpacedText, StretchedFormItem } from './styledComponents';

const { Title, Text } = Typography;

interface DeclarationInformationCardProps {
  mobile?: string;
  loginId?: string;
  initialPrefix?: string;
  isMobileValid?: boolean;
  onMobilePrefixChange?: (prefix: string) => void;
}

const DeclarationInformationCard = ({
  loginId,
  initialPrefix,
  mobile,
  isMobileValid = true,
  onMobilePrefixChange,
}: DeclarationInformationCardProps): JSX.Element => {
  const { t } = useTranslation();

  const addonBefore = (
    <Form.Item initialValue={initialPrefix ?? defaultPrefix} name="countryCode" noStyle>
      <MobileNumberPrefix defaultValue={initialPrefix} handleChange={onMobilePrefixChange} />
    </Form.Item>
  );

  return (
    <Card bodyStyle={{ paddingBottom: 0 }} title={<Title level={4}>{t('migration.existingMemberLoginInfo')}</Title>}>
      <Space size={16} direction="vertical">
        <SpacedText type="secondary">{t('migration.memberDeclarationDescription')}</SpacedText>
        <StretchedFormItem
          required
          name="loginId"
          label={<Text>{t('migration.selfDefinedId')}</Text>}
          rules={[
            {
              required: true,
              message: t('migration.error.selfDefinedIdIsRequired'),
            },
          ]}
        >
          <Input placeholder={t('migration.selfDefinedIdPlaceholder')} disabled={!!loginId} />
        </StretchedFormItem>
        {!mobile && (
          <StretchedFormItem
            name="mobile"
            label={<Text>{t('migration.mobile')}</Text>}
            rules={[
              {
                validator: () =>
                  isMobileValid ? Promise.resolve() : Promise.reject(new Error(t('registration.error.invalidMobile'))),
              },
            ]}
          >
            <Input addonBefore={addonBefore} placeholder={t('migration.mobilePlaceholder')} />
          </StretchedFormItem>
        )}
        <StretchedFormItem
          required
          name="declaration"
          valuePropName="checked"
          initialValue={false}
          rules={[
            {
              required: true,
              validator: (_, value) =>
                value ? Promise.resolve() : Promise.reject(new Error(t('migration.error.tncIsRequired'))),
            },
          ]}
        >
          <Checkbox>
            <CommonTnc />
          </Checkbox>
        </StretchedFormItem>
      </Space>
    </Card>
  );
};

export default DeclarationInformationCard;
